/**
 * <script type="application/ld+json"> entry for useHead. The JSON goes in innerHTML, serialised here with "<"
 * escaped (titles, descriptions and names come from Wapers: a "</script>" must not close the tag).
 * The schema helpers used to pass a "json" key, which useHead does not know: from 2023 to 10/2026 every page
 * rendered empty <script type="application/ld+json" json="[object Object]"> tags instead of its structured data.
 */
export const jsonLdScript = (data: Record<string, unknown>, key?: string) => ({
  type: 'application/ld+json',
  ...(key ? { key } : {}),
  innerHTML: JSON.stringify(data).replace(/</g, '\\u003c'),
})
